import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { OrderCompleteComponent } from './containers/order-complete/order-complete.component';
import {SharedModule} from '../../shared/shared.module';
import { OrderConfirmationComponent } from './containers/order-confirmation/order-confirmation.component';
import {OrderCompletedWidgetComponent} from './containers/order-completed-widget/order-completed-widget.component';

const routes: Routes = [
  {
    path: '',
    component: OrderCompleteComponent
  },
  {
    path: 'order-confirmation',
    component: OrderConfirmationComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrderCompleteComponent, OrderConfirmationComponent, OrderCompletedWidgetComponent]
})
export class OrderCompletePageModule {}
